import {Injectable} from '@angular/core';
import {BaseDaoService, handleError} from '@q9elements/ui-kit/common';

@Injectable({
  providedIn: 'root'
})
export class StoryLinkService extends BaseDaoService {
  public bulkAddNodesToStory(url: string, data: unknown) {
    return this.http.post(`${url}/stories/bulk/nodes`, data).pipe(handleError());
  }
}
